var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{staticClass:"input",attrs:{"disabled":_vm.disabled,"value":_vm.materialQuantitySelect,"type":"number"},on:{"input":function($event){return _vm.handleChangeMaterialQuantitiy($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }